import script from "./whDOnceImg5_t1A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg5_t1A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg5_t1A.vue?vue&type=style&index=0&id=5208357b&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5208357b"]])

export default __exports__